(function () {
  function selectScenarioBundle(carousel, nextIndex) {
    const slides = Array.from(carousel.querySelectorAll('[data-campaign-scenario-slide]'));
    if (slides.length < 2) return;
    const normalizedIndex = (nextIndex + slides.length) % slides.length;
    slides.forEach(function (slide, index) {
      slide.hidden = index !== normalizedIndex;
      slide.setAttribute('aria-hidden', index === normalizedIndex ? 'false' : 'true');
    });
    carousel.dataset.activeSlide = String(normalizedIndex);
  }

  document.addEventListener('click', function (event) {
    const gameButton = event.target.closest('.campaign-surprise__game');
    if (gameButton && typeof window.eaOpenPopup === 'function') window.eaOpenPopup();

    const playButton = event.target.closest('[data-campaign-video-play]');
    if (playButton) {
      const media = playButton.closest('.campaign-bonus__media'); const video = playButton.previousElementSibling;
      if (!media || !video || video.tagName !== 'VIDEO') return;
      media.classList.add('is-playing'); video.controls = true;
      video.play().catch(function () { media.classList.remove('is-playing'); video.controls = false; });
    }
    const quantityButton = event.target.closest('[data-campaign-quantity]');
    if (quantityButton) {
      const root = quantityButton.closest('.campaign-product-card, .campaign-bonus__body');
      const form = root && root.querySelector('form'); const display = root && root.querySelector('[data-campaign-quantity-value]');
      const input = form && form.querySelector('[name="quantity"]'); if (!input || !display) return;
      input.value = Math.max(1, Number(input.value) + Number(quantityButton.dataset.campaignQuantity)); display.textContent = input.value;
    }
    const scenarioNav = event.target.closest('[data-campaign-scenario-nav]');
    if (scenarioNav) {
      const carousel = scenarioNav.closest('[data-campaign-scenario-carousel]');
      if (carousel) {
        const currentIndex = Number(carousel.dataset.activeSlide) || 0;
        selectScenarioBundle(carousel, currentIndex + Number(scenarioNav.dataset.campaignScenarioNav));
      }
    }
    const buyButton = event.target.closest('[data-campaign-buy-now]');
    if (buyButton && !buyButton.disabled) {
      const form = document.getElementById(buyButton.dataset.form); const quantity = form && form.querySelector('[name="quantity"]');
      const variant = form && form.elements.namedItem('id');
      const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      window.location.href = root + 'cart/' + (variant ? variant.value : buyButton.dataset.variantId) + ':' + (quantity ? quantity.value : 1);
    }
  });

})();
